/** @format */

import React from 'react';
import { Modal, Header, Icon, Form } from 'semantic-ui-react';

const AdminPageModal = props => {
  let { title } = props;
  title = title ? title : props.currentItem.uid ? 'Modifica' : 'Aggiungi';
  return (
    <Modal open={props.open}>
      <Modal.Content>
        <Header className="modal-header" as="h3">
          <small>
            <Icon name="cog" />
            {title}
          </small>
        </Header>
        <div className="header-spacer" />
        <Form onSubmit={props.onSubmit} className="modal-form" size="small">
          {props.children}

          {props.errors && <div className="error">Compila tutti i campi</div>}
          <Form.Group widths="equal">
            {props.isEdit && props.onDelete && (
              <Form.Button
                type="button"
                color="red"
                fluid
                onClick={() => props.onDelete(props.currentItem.uid)}
              >
                <Icon name="times" /> Elimina
              </Form.Button>
            )}
            <Form.Button type="submit" color="green" fluid>
              <Icon name="save" />{' '}
              {props.currentItem.uid ? 'Conferma modifica' : 'Aggiungi'}
            </Form.Button>
          </Form.Group>
        </Form>
        <div className="close-button" onClick={props.toggleEditModal}>
          X
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default AdminPageModal;
